import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    formContainer: {
        overflow: 'hidden',
        height: 'calc(100% - 100px)' // previously - 118px
    },
    scrollbarContainer: {
        '& > div': {
            overflowX: 'hidden !important' as any,
            height: '99%',
        }
    },
    paper: {
        padding: '15px',
        marginBottom: 16,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    widgetContent: {
        width: '100%',
    },
    name: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#000000',
    },
    actionsContainer: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        zIndex: 2
    },
    actions: {
        display: 'flex',
        gap: '10px',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        flexDirection: 'column',
        position: 'relative',
    },
    draggable: {
        cursor: 'grab'
    },
    columnContainer: {
    },
    leftColumn: {
        'padding': '15px',
        'width': 'calc(100% - 20px)',
        '& .MuiPaper-root': {
            marginBottom: 0
        }
    },
    rightColumn: {
        'backgroundColor': '#999999',
        'padding': '10px',
        'height': '100%',
        '& .MuiPaper-root': {
            marginBottom: '10px'
        }
    },
    fullWidthCard: {
        width: '100%',
    },
    thirdWidthCard: {
        width: '100%', // Grid item with xs=4 handles the width
    },
    leftColumnContainer: {
        paddingRight: '15px !important',
    },
});
